/*!
 * Actic Learning Resources Catalog Search 1.0
 * Copyright (c) 2020 Frameworks AS
 */

var UArctic = window.UArctic || {}; //Creates a namespace to keep our method away from colliding with other code
UArctic.Search = UArctic.Search || {};

UArctic.Search.LearningResourcesCatalog = {
    globalSettings: {
        formSelector: '#alrSearchForm',
        searchButtonSelector: '#btnSearch',
        termFieldSelector: '#txtSearchTerm',
        fieldOfStudyFieldSelector: '#ddlFieldsOfStudy',
        organizationFieldSelector: '#ddlOrganizations',
        resourceTypeFieldSelector: '#ddlResourceType',
        toggleFilterButtonSelector: '#btn_collapse_form',
        wrapperSelector: '#searchbox',
        searchOnInit: 'false',
        catalogUrl: ''
    },
	/*
	 Default options:
	 -- catalogUrl: '',
	 -- formSelector: '#alrSearchForm',
	 -- searchButtonSelector: '#btnSearch',
	 -- termFieldSelector: '#txtSearchTerm',
     -- fieldOfStudyFieldSelector: '#ddlFieldsOfStudy',
     -- organizationFieldSelector: '#ddlOrganizations',
     -- resourceTypeFieldSelector: '#ddlResourceType',
	 -- toggleFilterButtonSelector: '#btn_collapse_form',
	 -- wrapperSelector: '#searchbox',
	 -- searchOnInit: 'false'
	 */
    initFullForm: function (options) {

        var settings = $.extend(UArctic.Search.LearningResourcesCatalog.globalSettings, options);
        var doSearch = function (event) {
            var $form = $(settings.formSelector);
            event.stopImmediatePropagation();
            window.UArctic.Search.LearningResourcesCatalog.search($form.serialize());
            return false;
        };

        $(settings.searchButtonSelector).on('click', function (event) {
            return doSearch(event);
        });

        $(settings.formSelector).on('submit', function (event) {
            return doSearch(event);
        });

        $(settings.toggleFilterButtonSelector).on('click', function () {
            var $btn = $(this);
            var $searchWrapper = $(settings.wrapperSelector);
            if ($searchWrapper.hasClass('form-collapsed')) {
                $searchWrapper.removeClass('form-collapsed');
                $btn.html('<i class="fa fa-angle-double-up"></i>&nbsp;Hide advanced filters&nbsp;<i class="fa fa-angle-double-up"></i>');
            } else {
                $searchWrapper.addClass('form-collapsed');
                $btn.html('<i class="fa fa-angle-double-down"></i>&nbsp;Show advanced filters&nbsp;<i class="fa fa-angle-double-down"></i>');
            }
        });

        // UArctic.Search.LearningResourcesCatalog.initLookupFields(options);

        if (settings.searchOnInit === 'true') {
            var $form = $(settings.formSelector);
            window.UArctic.Search.LearningResourcesCatalog.search($form.serialize());
        }
    },

	/*
	 Default options:
	 -- formSelector: '#alrSearchForm',
	 -- searchButtonSelector: '#btnSearch',
	 -- termFieldSelector: '#txtSearchTerm',
        fieldOfStudyFieldSelector: '#ddlFieldsOfStudy',
        organizationFieldSelector: '#ddlOrganizations',
        resourceTypeFieldSelector: '#ddlResourceType',
	 -- toggleFilterButtonSelector: '#btn_collapse_form',
	 -- wrapperSelector: '#searchbox'
	 */
    initLookupFields: function (options) {
        var settings = $.extend(UArctic.Search.LearningResourcesCatalog.globalSettings, options);

        $(settings.formSelector + ' button[type=reset]').on('click', function () {
            $(settings.formSelector + ' select').each(function (i, ddctrl) {
                $(ddctrl).children('option:selected').removeAttr('selected');
                $(ddctrl).children('option[value=""]').attr('selected', 'selected');
            });
        });

        $('select[data-lookup]').on('change', function () {
            var lookup = $(this).data('lookup');
            window.UArctic.Search.LearningResourcesCatalog.updateLookupData(lookup);
        });
    },

    updateLookupData: function (updater) {
        // This function is probably way over complicated, but it tries to only show dropdown options that actually will return results.
        var currentFieldOfStudyId = null, resourceType = null, selectLevel = 0,
            settings = UArctic.Search.LearningResourcesCatalog.globalSettings;

        switch (updater) {
            case "resourceType":
                resourceType = $(settings.resourceTypeFieldSelector).val();
                selectLevel++;
            case "fieldOfStudyId":
                currentFieldOfStudyId = parseInt($(settings.fieldOfStudyFieldSelector).val());
                selectLevel++;
                break;
            default:
        }

        var buildSelect = function (selector, data, level) {
            if (selectLevel >= level) {
                return;
            }
            var selectedValue = $(selector).val();
            var items = '';
            var matchedSelected = false;
            $.each(data, function (i, item) {
                items += '<option value="' + item.Key + '"';
                if (item.Key === selectedValue) {
                    matchedSelected = true;
                    items += ' selected';
                }
                items += '>' + item.Value + '</option>';
            });
            if (matchedSelected) {
                items = '<option value="">--- All ---</option>' + items;
            } else {
                items = '<option value="" selected>--- All ---</option>' + items;
            }
            $(selector).html(items);
        };

        $.ajax({
            url: '/Umbraco/Api/LearningResourcesCatalogApi/GetFilterData',
            type: 'GET',
            data: { 'FieldOfStudyId': currentFieldOfStudyId,  'ResourceType': resourceType },
            dataType: 'json',
            success: function (response) {
                buildSelect(settings.resourceTypeFieldSelector, response.ResourceTypes, 3);
                buildSelect(settings.fieldOfStudyFieldSelector, response.FieldsOfStudy, 4);
            },
            error: function (error) {
                // TODO: Better error handling?
                console.log(error);
                alert('An unexpected error ocurred while fetching lookup data');
            }
        });
    },

    search: function (searchData) {
        var $msg = $('#search_message');
        var $result = $('#search_results');
        window.location.hash = "";
        $msg.hide();
        $.ajax({
            url: '/Umbraco/Api/LearningResourcesCatalogApi/Search/',
            type: 'POST',
            data: searchData,
            dataType: 'json',
            success: function (response) {
                UArctic.Search.LearningResourcesCatalog.fillResultTable(response.ResultList);
                if (location.hostname !== "localhost") {
                  window.gtag('event', 'search', {
                    'event_label': searchData.SearchString
                  });
                  // OLD ga tag code : window.ga('send', 'pageview', location.pathname + '?q=' + searchData.SearchString);
                }
            },
            error: function (error) {
                if (error.responseJSON.Message) {
                    $msg.html('<div class="search-error">' + error.responseJSON.Message + '</div>');
                    $msg.show(300);
                } else {
                    alert('An unexpected error occured when perfoming the search. Please reload this page and try again.');
                }
            }
        });
    },

    fillResultTable: function (data) {
        var settings = UArctic.Search.LearningResourcesCatalog.globalSettings;
        var $resultTable = $('#search_results tbody');
        var $result = $('#search_results');
        $resultTable.html('');
        if (data.length > 0) {
            $result.show();
            for (var i = 0; i < data.length; i++) {
                var row = ' \
                    <tr> \
                        <td data-search-score="' + data[i].Score + '">' + (i + 1) + '</td> \
                        <td><a class="theme-link popover-trigger" data-toggle="popover" data-content="' + data[i].ShortDescription + '" href="' + settings.catalogUrl + 'details/?id=' + data[i].Id + '">' + data[i].Name + '</a></td> \
                        <td>' + data[i].ResourceType + '</td> \
                        <td>' + data[i].Language + '</td> \
                        <td>' + data[i].FieldOfStudy + '</td> \
                    </tr>';
                $resultTable.append(row);
            }
            $('#search_results table').addClass('sortable');
            $.bootstrapSortable();
            $resultTable.find('a.popover-trigger').popover({
                container: 'body',
                placement: 'auto',
                trigger: 'hover',
                delay: { show: 300 }
            });
            window.location.hash = "search_results";
        } else {
            $resultTable.html('<tr><td colspan="5">The search didn\'t return any results</td></tr>');
            $result.show();
        }
    }
};